const labelsValidationNL = {
    "name": {
        "required": "Naam van het label is verplicht",
        "unique": "Oeps! Dit label bestaat al en is eigendom van een andere gebruiker. Probeer een andere labelnaam. Als u wettelijk eigenaar bent van deze labelnaam en u bezit het naamcopyright, neem dan contact op met ons ondersteuningsteam.",
        "available": "Labelnaam is beschikbaar",
        "invalid": "Labelnaam is ongeldig"
    },
    "year": {
        "required": "Oprichtingsjaar is verplicht",
        "numeric": "De waarde is geen nummer",
        "stringLength": "Oprichtingsjaar moet 4 cijfers lang zijn"
    },
    "releaseCatalog": {
        "required": "Uitgaven in catalogus zijn verplicht",
        "numeric": "De waarde is geen nummer"
    },
    "logo": {
        "required": "Het logo is verplicht",
        "dimensions": "De label logo grootte moet 1000 x 1000 px zijn, JPG/JPEG/PNG.",
        "choose": "Kies alstublieft een afbeelding",
        "file": "Upload alstublieft JPG of PNG formaten, minimale resolutie 1000x1000px. Max grootte 2MB"
    },
    "promo_graphic": {
        "dimensions": "De label promotionele grafiek grootte moet 960 x 150 px zijn, JPG/JPEG/PNG.",
        "choose": "Kies alstublieft een afbeelding",
        "file": "Upload JPG of PNG formaten, minimale resolutie 960x150px"
    }
};

export default labelsValidationNL;